import { action } from "@ember/object"
import { inject as service } from "@ember/service"
import Component from "@glimmer/component"
import type { Session } from "@shared/models/session"
import belongsTo from "cc-frontend/helpers/belongs-to"
import LiveQueryResource from "cc-frontend/helpers/live-query"
import type EmberStore from "cc-frontend/services/ember-store"
import { use } from "ember-could-get-used-to-this"

interface Args {
  Args: {
    model: Session
    selectAction: (id: string) => {}
  }
}

export default class AdminActionsForSessionList extends Component<Args> {
  @service("ember-store") declare store: EmberStore

  @belongsTo("model", "user") user

  selectedActionId = null
  nextOffset = 0

  @use sessionQuery = new LiveQueryResource(() => [
    "actions_for_session",
    this.args.model.id,
    this.nextOffset,
  ])

  @action
  loadMoreBelow() {
    this.nextOffset = this.nextOffset + 100
  }
}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    AdminActionsForSessionList: typeof AdminActionsForSessionList
  }
}
